import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { Drawer, Menu } from 'antd'
import Animate from 'rc-animate'

import useWallet from '_src/hooks/useWallet'
import { useAppSelector } from '_src/store/hooks'
import { verifySignStatus } from '_src/contracts/sign'

import Icon from '../Icon'
import Button from '../Button'
import { handleLanguageClick } from '../Language'

import { navs, exploreUrl } from './navs'

import './index.less'

const InftMenu = ({ type }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { connected, networkId, userData } = useAppSelector((store) => store.global)
  const activeUrl = useAppSelector((store) => store.menu.activeUrl)

  const { walletConnect } = useWallet()

  const [visible, setVisible] = useState(false)
  const [show, setShow] = useState(0)

  const [openKeys, setOpenKeys] = useState([exploreUrl])

  const goLink = async (item, type = 'pc') => {
    if (Object.prototype.hasOwnProperty.call(item, 'children')) return

    const { url = '' } = item
    type == 'mobile' && onClick()
    // 创建需要权限
    if (url == '/create') {
      if (!connected) {
        const res = await walletConnect().catch((error) => {
          console.log('钱包连接失败', error)
        })
        console.log('是否连接成功', res)
      }
      const res = await verifySignStatus().catch((error) => {
        // 拒绝签名
        console.log(error)
        return
      })
      if (!res) return
      url && history.push(url)
    } else {
      url && history.push(url)
    }
    type = 'pc' && setShow(-1)
  }

  const handleMenuClick = (item) => {
    // 多语言进行切换
    const { key = '' } = item

    if (key && key.includes('/')) {
      goLink({ url: key }, 'mobile')
    } else {
      // 多语言进行切换
      handleLanguageClick(key, () => {
        setOpenKeys([exploreUrl])
        onClick()
      })
    }
  }

  const handleMenuOpen = (keys) => {
    const { [keys.length - 1]: last } = keys

    if (last) {
      setOpenKeys([last])
    } else {
      setOpenKeys([])
    }
  }

  const onClick = () => {
    setVisible(!visible)
  }

  const handleLogin = async () => {
    setVisible(false)

    const res = await walletConnect().catch((error) => {
      console.log('钱包连接失败', error)
    })
    console.log('是否连接成功', res)
    setVisible(false)
  }

  const showMenuItem = (index) => {
    setShow(index)
  }

  return (
    <>
      {type === 'mobile' ? (
        <div className="mobile-menu-container">
          {visible ? (
            <Icon onClick={onClick} type="icon-closed" className="menu-icon" />
          ) : (
            <Icon onClick={onClick} type="icon-fold" className="menu-icon" />
          )}

          <Drawer
            onClose={onClick}
            placement="right"
            closable={false}
            visible={visible}
            className="mobile-drawer-container"
          >
            <Menu
              forceSubMenuRender={true}
              className="mobile-cust-menu-container"
              // expandIcon={<Icon type="icon-menu-arrow" className="mobile-drawer-menu-right" />}
              onClick={handleMenuClick}
              onOpenChange={handleMenuOpen}
              openKeys={openKeys}
              defaultOpenKeys={[exploreUrl]}
              mode="inline"
              items={navs(networkId, t, true)}
            />

            {Object.keys(userData).length > 0 ? (
              <></>
            ) : (
              <Button className="mobile-menu-connect-button" onClick={handleLogin}>
                {t('common.connect_wallet')}
              </Button>
            )}
          </Drawer>
        </div>
      ) : (
        <div className="pc-menu-container">
          {navs(networkId, t).map((item, index) => (
            <div
              key={index}
              onClick={() => {
                goLink(item)
              }}
              onMouseEnter={() => {
                showMenuItem(index)
              }}
              onMouseLeave={() => {
                setShow(-1)
              }}
              className={classNames('pc-menu-item', {
                'inft-menu-active': activeUrl.includes(item.url),
              })}
            >
              <div>{item.label}</div>
              {item?.children && (
                <Animate transitionName="inft-fade" transitionAppear>
                  {show == index && (
                    <div className="menu-item-container">
                      {item.children.map((it, ix) => (
                        <div
                          onClick={() => {
                            goLink(it)
                          }}
                          className={classNames('menu-item-content', {
                            'inft-menu-active': activeUrl.includes(it.url),
                          })}
                          key={ix}
                        >
                          {it.label}
                        </div>
                      ))}
                    </div>
                  )}
                </Animate>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default InftMenu
